import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, fonts, mixins } from "@similarweb/styles";
import { capitalizeFirstLetter } from "app/pages/sales-intelligence/common-components/styles";
import { CenteredFlexRow, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";

export const StyledEventItemWrapper = styled(FlexRow)`
    column-gap: 8px;
    user-select: none;

    color: ${colorsPalettes.carbon[400]};
`;

export const StyledIconWrapper = styled(CenteredFlexRow)`
    flex: 0 0 24px;
    height: 24px;
    width: 24px;

    border-radius: 50%;
    background-color: ${colorsPalettes.bluegrey[200]};
`;

export const StyledIcon = styled(SWReactIcons)`
    & svg path {
        fill: ${colorsPalettes.bluegrey[500]};
    }
`;

export const StyledEventText = styled.span`
    ${mixins.setFontVariant("value")};
    ${capitalizeFirstLetter};

    font-family: ${fonts.$dmSansFontFamily};
    color: currentcolor;
    white-space: break-spaces;
`;

export const StyledEventDate = styled.div`
    ${mixins.setFontVariant("listItem3", colorsPalettes.carbon[250])};
`;
